module.exports = __webpack_public_path__ + "static/media/video.4c9ab10e.svg";